import {GET, POST} from '../index'
// 获取游戏列表
export const getList = (data) => {
  return POST('/game/list', data)
}

// 获取游戏类型列表
export const getTypeList = () => {
  return GET('/game/type/list')
}
// 更新指定状态
export const changeStatus = (data) => {
  return POST('/game/change/status', data)
}

// 获取支付方式列表
export const getPayList = () => {
  return GET('/game/pay')
}

// 添加游戏类型
export const addTypeName = (data) => {
  return POST('/game/add/type', data)
}

// 添加游戏
export const addGame = (data) => {
  return POST('/game/add', data)
}

// 更改排序
export const storeSort = (data) => {
  return POST('/game/sort', data)
}

// 获取基本数据
export const getInfo = (data) => {
  return GET('/game/info', data)
}

// 更改基本数据
export const editInfo = (data) => {
  return POST('/game/edit/info', data)
}

// 获取链接数据
export const getLinkInfo = (data) => {
  return GET('/game/link', data)
}

// 更改链接数据
export const editLink = (data) => {
  return POST('/game/edit/link', data)
}

// 获取图片数据
export const getImgInfo = (data) => {
  return GET('/game/img', data)
}

// 保存游戏图片
export const saveGameImg = (data) => {
  return POST('/game/save/img', data)
}

// 获取所有游戏列表
export const getAllGameList = () => {
  return GET('/game/all')
}



// WEBPACK FOOTER //
// ./src/api/game/index.js